import { cn } from "@/lib/utils";
import { AlertCircle, Inbox, Loader2 } from "lucide-react";

export function LoadingState({ className }: { className?: string }) {
  return (
    <div
      className={cn(
        "flex flex-col items-center justify-center gap-2 py-12 text-muted-foreground",
        className,
      )}
    >
      <Loader2 className="h-5 w-5 animate-spin" />
      <span className="text-xs">Loading…</span>
    </div>
  );
}

export function ErrorState({
  error,
  onRetry,
  className,
}: {
  error: { message: string; status?: number };
  onRetry?: () => void;
  className?: string;
}) {
  return (
    <div
      className={cn(
        "flex flex-col items-start gap-2 rounded-lg border border-destructive/30 bg-destructive/5 p-4 text-sm",
        className,
      )}
    >
      <div className="flex items-center gap-2 text-destructive">
        <AlertCircle className="h-4 w-4" />
        <span className="font-medium">
          Failed to load{error.status ? ` (${error.status})` : ""}
        </span>
      </div>
      <div className="text-muted-foreground">{error.message}</div>
      {onRetry && (
        <button
          type="button"
          onClick={onRetry}
          className="mt-1 rounded-md border px-2 py-1 text-xs hover:bg-accent"
        >
          Retry
        </button>
      )}
    </div>
  );
}

export function EmptyState({
  title,
  description,
  className,
}: {
  title: string;
  description?: string;
  className?: string;
}) {
  return (
    <div
      className={cn(
        "flex flex-col items-center justify-center gap-2 rounded-lg border border-dashed py-12 text-center text-muted-foreground",
        className,
      )}
    >
      <Inbox className="h-6 w-6" />
      <div className="text-sm font-medium">{title}</div>
      {description && <div className="text-xs">{description}</div>}
    </div>
  );
}
